import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Directive({
  selector: '[appDownloadWithCredential]'
})
export class DownloadWithCredentialDirective {
  fileUrl!: string;
  @Output() downloadProgress = new EventEmitter<number | undefined>();

  @HostListener('click', ['$event']) download(event: any) {
    event.stopImmediatePropagation();
    event.preventDefault();
    this.fileUrl = this.el.nativeElement.href;
    this.el.nativeElement.src = ''; // Prevents original file from download

    // Fetching file as blob
    this.http.get(this.fileUrl, {
      responseType: 'blob', reportProgress: true, observe: 'events'
    }).subscribe((event) => {
      if (event.type === HttpEventType.DownloadProgress) {
        this.downloadProgress.emit(Math.round(100 * event.loaded / (event.total as number)));
      }else if (event.type === HttpEventType.Response) {
        const response = event.body as Blob;
        // Creating an object URL for the blob data and setting it as the src of the image
        const reader = new FileReader();
        reader.onloadend = () => {
          const dlink = document.createElement('a');
          dlink.download = 'output.zip';
          dlink.href = reader.result as string;
          dlink.click();
        };
        reader.readAsDataURL(response);
        this.downloadProgress.emit(undefined);
      }
    });
  }


  constructor(private el: ElementRef, private http: HttpClient) {
  }

  ngOnInit() {
  }

}
